import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '../../Checkbox'

import styles from './styles'

const MultiOption = ({ selected, focused, ...props }) => (
  <li role="option" aria-selected={selected}>
    <Checkbox
      checked={selected}
      className={styles.focused(focused, props.theme)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  </li>
)
MultiOption.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  focused: PropTypes.string,
  theme: PropTypes.string,
}

export default MultiOption
